import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../../assets/icons/Search.svg";
import "./PatientStyles.css";
import PatientLoader from "../../common/PatientLoader";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getFullName } from "../../../util/helpers";
const SearchPatientComponent = () => {
  const [term, setTerm] = useState("");
  const { loading, patientData } = useSelector((state) => state.patient);
  return (
    <div
      className="container-fluid d-flex w-100 justify-content-start bg-white"
      style={{ margin: "0px", padding: "1rem 0px" }}
    >
      <div
        className="search-container d-flex"
        style={{ marginLeft: "30px", position: "relative" }}
      >
        <SearchIcon style={{ marginTop: "3%" }} />
        <input
          placeholder="Search Patient"
          onChange={(e) => {
            setTerm(e.target.value);
          }}
        />
        {term !== "" && (
          <div className="floating-search-container">
            {loading ? (
              <PatientLoader showText={false} />
            ) : (
              <>
                {patientData
                  ?.filter(
                    (item) =>
                      item?.first_name?.toLowerCase()?.includes(term) ||
                      item?.last_name?.toLowerCase()?.includes(term)
                  )
                  .map((item) => {
                    return (
                      <Link
                        onClick={() => {
                          setTerm("");
                        }}
                        key={item?.id}
                        to={`/patients/${item?.id}`}
                        className="floating-search-container-item"
                      >
                        {getFullName(item)}
                      </Link>
                    );
                  })}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPatientComponent;
